const config = {
    API_URL:         process.env.REACT_APP_TRADVECTOR_API_URL,
    AUTH0_DOMAIN:    process.env.REACT_APP_TRADVECTOR_AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: process.env.REACT_APP_TRADVECTOR_AUTH0_CLIENT_ID,
    AUTH0_AUDIENCE:  process.env.REACT_APP_TRADVECTOR_AUTH0_AUDIENCE,
};
export default config;
